__turbopack_context__.v({
  "desktop-only": "Uhr7Tq_desktop-only",
  "fill": "Uhr7Tq_fill",
  "image": "Uhr7Tq_image",
  "mobile-only": "Uhr7Tq_mobile-only",
});
